import { SVGProps } from 'react'

function SvgAmex(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={70}
      height={48}
      viewBox="0 0 70 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <title>American Express</title>
      <path
        d="M0 6a6 6 0 0 1 6-6h58a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z"
        fill="#1F72CD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 1H6a5 5 0 0 0-5 5v36a5 5 0 0 0 5 5h58a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5ZM6 0a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h58a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
        fill="#788BA5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.55 17 6 31.494h7.84l.973-2.311h2.221l.972 2.31h8.63V29.73l.77 1.764h4.464l.769-1.802v1.802h17.948l2.182-2.251 2.044 2.25 9.219.02-6.57-7.226L64.032 17h-9.076l-2.125 2.21L50.852 17H31.327l-1.677 3.74L27.934 17H20.11v1.704L19.24 17h-6.69Zm26.802 2.058h10.306l3.153 3.405 3.254-3.405h3.152l-4.79 5.227 4.79 5.167h-3.295l-3.152-3.445-3.271 3.445H39.352V19.058Zm2.545 4.052v-1.9h6.431l2.806 3.036-2.93 3.053h-6.307v-2.073h5.623V23.11h-5.623Zm-27.83-4.052h3.821l4.344 9.828v-9.828h4.187l3.355 7.047 3.093-7.047h4.166v10.4h-2.535l-.02-8.15-3.696 8.15h-2.268l-3.716-8.15v8.15h-5.214l-.989-2.331h-5.341l-.986 2.33H9.473l4.592-10.399Zm.099 5.913 1.76-4.153 1.757 4.153h-3.517Z"
        fill="#fff"
      />
    </svg>
  )
}
export default SvgAmex
